module.exports = __webpack_public_path__ + "img/Weapon_166.9bec15c2.png";